module.exports = __webpack_public_path__ + "img/muscles-vue-face.4f28ad5a.png";